import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { ErpSyncSystemStatus } from './erp-system-status.enum';

export const TenantStatusMatrixRowSchema = z
    .object({
        tenantId: z.string(),
        displayName: z.string(),
        buyers: z.number(),
        invoices: z.number(),
        payments: z.number(),
        total: z.number(),
        status: EnumSchema(ErpSyncSystemStatus),
    })
    .strict();

export interface TenantStatusMatrixRow extends z.infer<typeof TenantStatusMatrixRowSchema> {}

export const TenantStatusMatrixCountsSchema = z
    .object({
        buyers: z.number(),
        invoices: z.number(),
        payments: z.number(),
    })
    .strict();

export interface TenantStatusMatrixCounts extends z.infer<typeof TenantStatusMatrixCountsSchema> {}
